<template>
  <div>
    <div class="space-x-3">
      <BaseButton v-if="isPending || isCancelled" success @click="startCampaign">
        {{ isPending ? 'Start now' : 'Resume' }}
      </BaseButton>
      <BaseButton v-if="isPending || isQueued || isRunning" danger @click="cancelCampaign">
        Cancel
      </BaseButton>
    </div>
    <p v-if="errorMessage" class="mt-2 text-red-500 font-medium">
      {{ errorMessage }}
    </p>
    <ul v-if="validationErrors.length">
      <li v-for="(msg, msgIdx) in validationErrors" :key="msgIdx" class="mt-2 text-red-500">
        {{ msg }}
      </li>
    </ul>
  </div>
</template>

<script>
import { accountActiveSmsCampaignsClient } from '@/api/clients';

export default {
  props: {
    smsCampaign: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      validationErrors: [],
      errorMessage: '',
    };
  },
  computed: {
    isPending() {
      return this.smsCampaign.status === 'PENDING';
    },
    isQueued() {
      return this.smsCampaign.status === 'QUEUED';
    },
    isRunning() {
      return this.smsCampaign.status === 'RUNNING';
    },
    isCancelled() {
      return this.smsCampaign.status === 'CANCELLED';
    },
  },
  methods: {
    clearErrors() {
      this.errorMessage = '';
      this.validationErrors = [];
    },
    startCampaign() {
      this.clearErrors();
      accountActiveSmsCampaignsClient
        .store(this.smsCampaign.account_id, {
          sms_campaign_id: this.smsCampaign.id,
          skip_schedule: this.isPending,
        })
        .then((response) => {
          this.$router.replace({
            name: this.$route.name,
            params: {
              ...this.$route.params,
            },
            query: {
              updated: new Date().getTime(),
            },
          });

          return Promise.resolve(response);
        })
        .catch((error) => {
          if (error.response && error.response.status === 422) {
            this.validationErrors = Object.values(error.response.data.errors).flat(1);
          } else {
            this.errorMessage = error.message;
          }
        });
    },
    cancelCampaign() {
      this.clearErrors();
      accountActiveSmsCampaignsClient
        .destroy(this.smsCampaign.account_id, this.smsCampaign.id)
        .then((response) => {
          this.$router.replace({
            name: this.$route.name,
            params: {
              ...this.$route.params,
            },
            query: {
              updated: new Date().getTime(),
            },
          });

          return Promise.resolve(response);
        })
        .catch((error) => {
          if (error.response && error.response.status === 422) {
            this.validationErrors = Object.values(error.response.data.errors).flat(1);
          } else {
            this.errorMessage = error.message;
          }
        });
    },
  },
};
</script>
